import { render, staticRenderFns } from "./Issue.vue?vue&type=template&id=442186a2&scoped=true"
import script from "./Issue.vue?vue&type=script&lang=js"
export * from "./Issue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442186a2",
  null
  
)

export default component.exports